import { render, staticRenderFns } from "./ShowMyProfile.vue?vue&type=template&id=08af770c&"
import script from "./ShowMyProfile.vue?vue&type=script&lang=js&"
export * from "./ShowMyProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports